import { rpcCall } from "../../rpc/rpcCall.js";
import { useNuxtApp } from "nuxt/app";
import { useCurrentShop } from "./useCurrentShop.js";
export function useRpcCall(method) {
  const nuxtApp = useNuxtApp();
  const currentShop = useCurrentShop();
  return rpcCall(nuxtApp, method, currentShop.value);
}
